export default "__VITE_ASSET__BRYm0ECk__"